<script>
import {
  ref,
  computed,
  onMounted,
  onBeforeUnmount,
} from 'vue';

import { debounce } from 'lodash-es';

// Components
import BmChart from './Chart.vue';

// Directives
import scrollReveal from '@/directives/scroll-reveal';

import useFilterState from '@/state/useFilterState';
import useSectionState from '@/state/useSectionState';

export default {
  name: 'ChartSection',
  components: {
    'bm-chart': BmChart,
  },
  directives: {
    scrollReveal,
  },
  setup() {
    const {
      sectionCharts,
      setSectionWidth,
      getChartById,
    } = useSectionState();

    const { selectedMetric } = useFilterState();

    const chartSectionRef = ref(null);

    const validCharts = computed(() => sectionCharts.value.filter((c) => c.valid));

    const onChangeInterval = (id, value) => {
      getChartById(id).selectedInterval = value;
    };

    const onChangeCompareFirstCompset = (id, value) => {
      getChartById(id).compareFirstCompset = value;
    };

    const onChangeCompareSecondCompset = (id, value) => {
      getChartById(id).compareSecondCompset = value;
    };

    const onChangeSort = (id, value) => {
      getChartById(id).defaultSort = value;
    };

    const padding = 32;

    const calculateSectionWidth = () => {
      if (chartSectionRef.value) {
        const { offsetLeft } = chartSectionRef.value;
        const sectionWidth = chartSectionRef.value.closest('section.section')?.offsetWidth ?? 0
          - (offsetLeft * 2) // section padding
          - (padding * 2) // chart container padding
          - 2; // borders
        setSectionWidth(sectionWidth);
      }
    };

    const onHandleShowAll = (id) => {
      const tmpChartData = getChartById(id);
      getChartById(id).showAll = !tmpChartData.showAll;
    };

    onMounted(calculateSectionWidth);
    window.addEventListener('resize', debounce(calculateSectionWidth, 100));

    onBeforeUnmount(() => {
      window.removeEventListener('resize', debounce(calculateSectionWidth, 100));
    });

    return {
      validCharts,
      chartSectionRef,
      selectedMetric,
      onChangeInterval,
      onChangeCompareFirstCompset,
      onChangeCompareSecondCompset,
      onChangeSort,
      onHandleShowAll,
    };
  },
};
</script>
<template>
  <div
    ref="chartSectionRef"
    class="mt-4 flex flex-col gap-6"
  >
    <!-- charts -->
    <div
      v-for="(chart, i) in validCharts"
      :key="`${chart.title}_${chart.type}_${i}_${selectedMetric}`"
      v-scroll-reveal
      class="chart-container"
    >
      <bm-chart
        :chart="chart"
        @change-interval="(value) => onChangeInterval(chart.id, value)"
        @change-compare-first-compset="(value) => onChangeCompareFirstCompset(chart.id, value)"
        @change-compare-second-compset="(value) => onChangeCompareSecondCompset(chart.id, value)"
        @change-sort="(value) => onChangeSort(chart.id, value)"
        @handle-show-all="onHandleShowAll(chart.id)"
      />
    </div>
  </div>
</template>
<style scoped>
.chart-container:hover {
  @apply z-20;
}
</style>
